import React from "react";
import FormPackage from "../FormPackage";

export default function EditItemComponent({
  handleSubmit,
  isLoadingSubmit,
  initialValues,
}) {
  return (
    <FormPackage
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
      initialValues={initialValues}
      isEdit
    />
  );
}
